import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ExportOrdersActions as Actions,
  ExportOrdersRequestAction as RequestAction,
} from 'store/ducks/orders';

export function* exportOrdersRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('orders', {
      ...query,
      asList: 1,
      includeActionLogs: true, //Inclui logs das etapas/atualizações da ordem
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess(data);
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
